import * as React from "react";
import { forwardRef } from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.278 1.552v2.583H2.938l2.48-2.48A.858.858 0 0 0 4.204.44L.252 4.393a.86.86 0 0 0 0 1.214L4.204 9.56a.859.859 0 0 0 1.214-1.214l-2.48-2.488H15.14A.864.864 0 0 0 16 4.996V1.552a.864.864 0 0 0-.861-.861.864.864 0 0 0-.861.86" }));
const ForwardRef = forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
